(function () {
  const getVariant = () => new URL(location.href).searchParams.get('variant');
  let lastVariant = getVariant();

  // Fire custom event, wenn Dawn per push/replaceState die URL ändert
  ['pushState','replaceState'].forEach(fn => {
    const orig = history[fn];
    history[fn] = function () {
      const ret = orig.apply(this, arguments);
      const now = getVariant();
      if (now !== lastVariant) {
        lastVariant = now;
        window.dispatchEvent(new Event('variant:urlchange'));
      }
      return ret;
    };
  });

  // Auch Back/Forward abdecken
  window.addEventListener('popstate', () => {
    const now = getVariant();
    if (now !== lastVariant) {
      lastVariant = now;
      window.dispatchEvent(new Event('variant:urlchange'));
    }
  });

  // Reagieren: Seite neu laden, sobald die Variant-ID in der URL wechselt
  window.addEventListener('variant:urlchange', () => {
    if (!lastVariant) return;      // Initialen Zustand ignorieren
    location.reload();             // oder: location.replace(location.href);
  });
})();